import { css } from '@emotion/react';
import { dottedSeparatorStyle } from '../../patron-details.style';

export const separatorStyle = [
  dottedSeparatorStyle,
  css`
    &::before {
      top: -6px;
    }
  `,
];
